import "./Header.scss";

import React, { FC, useContext } from "react";

import HeaderMenu from "./HeaderMenu";
import NavContext from "../Nav/NavProvider";
import BurgerButton from "../../BurgerButton";

type HeaderProps = {
  alternativeSlug?: string;
  alternativeText?: string;
}

const Header: FC<HeaderProps> = ({alternativeSlug, alternativeText}) => {
  const { menuOpened, menuClosed, toggleMenu } = useContext(NavContext);

  return (
    <header
      className={`header${menuOpened ? " header--opened" : ""}${
        menuClosed === true ? " header--closed" : ""
      }`}
    >
      <div className={`header__gradient ${!menuOpened && menuClosed ? ' is-closed' : ''}`}></div>
      <div className="header__button">
        <BurgerButton opened={menuOpened} clickHandler={toggleMenu} />
      </div>
      <HeaderMenu isOpened={menuOpened} alternativeSlug={alternativeSlug} alternativeText={alternativeText} />
    </header>
  );
};

export default Header;
